<template>
  <div class="transactions">
    <div class="row justify-between align-center">
      <h3 class="transactions__heading">Последние операции со счетами</h3>
      <div class="transactions__controls">
        <date-picker
          :lang="$t('short lang')"
          :range="true"
          :confirm="true"
          class="controls__item controls__date-picker"
          value-type="format"
          v-model="dateRange"
          @change="handleDatePickerChange"
          format="DD.MM.YYYY"
          :clearable="false"
          :placeholder="$t('select date range')"
          :not-after="new Date()"
        />
      </div>
    </div>

    <table class="transactions__table table">
      <div v-show="isTransactionsListLoading" class="transactions__preloader">
        <spinner :animation-duration="1000" :size="60" :color="'#2E79EF'" />
      </div>
      <thead>
        <tr>
          <td class="table__head align-left">Счет</td>
          <td class="table__head align-left">Тип</td>
          <td class="table__head align-right">Дата</td>
          <td class="table__head align-right">Сумма</td>
          <td class="table__head align-right">{{ $t("currency") }}</td>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="transaction in transactionsList"
          :key="transaction.SORT_INDEX + transaction.FT_ID"
        >
          <td class="table__body align-left">{{ transaction.FT_ACCOUNT }}</td>
          <td class="table__body align-left">
            {{ transaction.OPERATION_TYPE }}
          </td>
          <td class="table__body align-right">
            {{ transaction.OPERATION_DATE }}
          </td>
          <td class="table__body align-right">
            {{ getFormatedMoney(transaction) }}
          </td>
          <td class="table__body align-right">
            {{ transaction.CURRENCY_CODE }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { HalfCircleSpinner } from "epic-spinners";
import DatePicker from "vue2-datepicker";
import accounting from "accounting";
import moment from "moment";

export default {
  components: {
    spinner: HalfCircleSpinner,
    "date-picker": DatePicker
  },
  data() {
    return {
      dateRange: [
        moment()
          .subtract(1, "months")
          .format("DD.MM.YYYY"),
        moment().format("DD.MM.YYYY")
      ]
    };
  },
  computed: {
    ...mapGetters(["transactionsList", "isTransactionsListLoading"])
  },
  methods: {
    handleDatePickerChange(dateRange) {
      this.$store.dispatch("changeDateRange", dateRange);
    },
    getFormatedMoney(transaction) {
      let money;
      if (transaction.CREDIT === "0" && transaction.DEBIT === "0") {
        return 0;
      } else if (transaction.CREDIT !== "0") {
        money = transaction.CREDIT;
      } else if (transaction.DEBIT !== "0") {
        money = transaction.DEBIT;
      }
      money = money.replace(",", ".");
      return accounting.formatMoney(money, "", 2, " ", ".");
    }
  },
  mounted() {
    this.$store.dispatch("fetchTransactions");
  }
};
</script>

<style scoped>
.transactions {
  padding: 30px 40px 0;
}

.transactions__heading {
  font-size: 36px;
  font-weight: normal;
}

.transactions__table {
  min-height: 20vh;
  position: relative;
}

.transactions__preloader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}
</style>
